// Confirmation page — fully rendered. Real and final.

import { Link, useSearch } from 'wouter';
import Seo from '../components/Seo';

export default function RequestSubmitted() {
  const search = useSearch();
  const id = new URLSearchParams(search).get('id');

  return (
    <section className="bg-ink text-white">
      <Seo
        title="Request received · WFS Chatbot"
        description="Your request is in the queue. We review every request manually and respond within two business days."
        path="/request-submitted"
        noindex
      />
      <div className="mx-auto max-w-prose px-6 py-32 md:py-40">
        <div className="mx-auto max-w-md text-center">
          <div
            className="mx-auto flex h-14 w-14 items-center justify-center rounded-full"
            style={{ background: 'rgba(124,255,184,0.12)', color: '#7CFFB8' }}
            aria-hidden
          >
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="20 6 9 17 4 12" />
            </svg>
          </div>
          <span className="rr-tag mt-6 inline-block">// request received</span>
          <h1 className="mt-4 text-display-md font-bold tracking-headline text-white">
            Request received.
          </h1>
          <p className="mt-4 text-base text-ash">
            Thanks. Your request is in the queue. We review every request manually, so you&apos;ll
            hear from us by email within two business days. If you&apos;re approved, we&apos;ll send a
            secure link to finish setting up your account.
          </p>
          {id && (
            <p className="mt-6 font-mono text-xs uppercase tracking-mono text-ash">
              ref: <span className="text-signal">{id}</span>
            </p>
          )}
          <Link
            href="/"
            className="mt-12 inline-flex items-center rounded-pill border border-ink-3 bg-ink-2 px-5 py-2.5 text-sm font-medium text-white hover:border-signal/50"
          >
            Back to homepage
          </Link>
        </div>
      </div>
    </section>
  );
}
